@if (bulkAppReviewCount) {
	<div class="review-apps-data">
		<div class="notification-container">
			<div class="row">
				<div class="col-md-auto icon-padding">
					<i class="fa fa-edit"></i>
				</div>
				<div class="col bulk-review-data">
					<div class="row">
						<div class="col d-flex">
							<span class="aut-review-count">
								You have {{ bulkAppReviewCount }} applications/appeals that
								require your review.
							</span>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<ea-button-link
								(click)="navigateToBulkReview()"
								data-cy="review-applications-now-link"
								>Review applications now</ea-button-link
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}
